<div class="relative inline-block" [style.width.px]="size()" [style.height.px]="size()">
  <canvas
    baseChart
    class="h-full w-full"
    [type]="'doughnut'"
    [data]="chartData()"
    [options]="chartOptions()"
    [style.cursor]="interactive() ? 'pointer' : 'default'"
    role="img"
    [attr.aria-label]="centerLabel() ?? 'Chart'"
    (chartHover)="onChartHover($event)"
    (chartClick)="onChartClick($event)"
  ></canvas>
  @if (centerLabel()) {
    <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
      <span
        class="font-bold leading-none"
        style="font-family: Poppins, sans-serif"
        [style.font-size.px]="centerLabelFontSize()"
        >{{ centerLabel() }}</span
      >
      @if (centerSubLabel()) {
        <span class="mt-1 whitespace-pre-line text-center text-sm text-muted">{{
          centerSubLabel()
        }}</span>
      }
    </div>
  }
</div>
